module.exports = __webpack_public_path__ + "img/10.b988caf4.png";